import type { Product } from "./products";
import type { RfidTag } from "./rfidTag";
import type { Site } from "./sites";

export enum ItemType {
  ITEM = "item",
  CAGE = "cage",
  CAGE_ITEM = "cage_item",
}

export interface CreateItemPayload {
  rfid_ids?: number[];
  product_id: number | string | undefined;
  date_of_circulation: Date | string | null;
  next_maintenance_date: Date | string | null;
  last_maintenance_date: Date | string | null;
  location: string;
  notify_email: string;
  external_id?: string;
  customize_columns: Record<string, string>;
  site_id: number | string | null;
  status: ItemStatus | string;
  maintenance_status: string;
  retrieval_status: string;
  stolen: boolean;
  type?: ItemType;
  cage_id?: number | null;
  cage_item_ids?: number[];
}

export enum ItemStatus {
  IN_STOCK_MAIN = "in_stock_main",
  IN_TRANSIT_TO_SUB = "in_transit_to_sub",
  INBOUND_SUB = "inbound_sub",
  IN_STOCK_SUB = "in_stock_sub",
  ISSUED_TO_FIELD = "issued_to_field",
  ON_SITE = "on_site",
  IN_STOCK = "in_stock",
  IN_DELIVERY = "in_delivery",
  IN_RETRIEVAL = "in_retrieval",
  IN_MAINTENANCE = "in_maintenance",
  MISSING = "missing",
  INCOMPLETE = "incomplete",
  DELIVERED = "delivered",
  STORM_STOCK = "storm_stock",
}

export enum MaintenanceStatus {
  IMPENDING = "impending",
  ON_TIME = "on_time",
  IN_PROGRESS = "in_progress",
  LATE = "late",
}
export enum RetrievalStatus {
  IMPENDING = "impending",
  ON_TIME = "on_time",
  IN_PROGRESS = "in_progress",
  LATE = "late",
}

export interface Item {
  id: number;
  rfid_tags: RfidTag[];
  product_id: number;
  date_of_circulation: string; // ISO string
  next_maintenance_date: string; // ISO string
  last_maintenance_date: string; // ISO string
  location: string;
  notify_email: string;
  external_id?: string;
  status: ItemStatus | string;
  retrieval_status: RetrievalStatus;
  maintenance_status: MaintenanceStatus;
  latitude: number | null;
  longitude: number | null;
  scan_count: number;
  site_id: number | null;
  customize_columns: {
    [key: string]: string;
  };
  createdAt: string; // ISO string
  updatedAt: string; // ISO string
  product: Product;
  site: Site;
  stolen?: boolean;
  type?: ItemType;
  cage?: Item | null;
  cage_items?: Item[];
  tag_id?: string;
  last_scan_data?: {
    time: string;
    type: 'scan' | 'refill'
  }
}

export interface SendMessagePayload {
  subject: string;
  message: string;
}

export interface MapItem {
  id: number;
  location: string;
  latitude: number | null;
  longitude: number | null;
  product_type: string | null;
  status: string;
}

export interface MapData {
  items: Item[];
  counts: Record<string, number>;
}
